import { i18nDefaultConfig } from "@gx1/gx-npm-lib";
import { i18nTemplate as gxNpmUiTranslations } from "@gx1/gx-npm-ui";
import { i18nTemplate as gxUiCommonTranslations } from "@gx1/gx-ui-common";
import { use } from "i18next";
import { initReactI18next } from "react-i18next";
import appTranslations from "./translations/template.json";

// eslint-disable-next-line react-hooks/rules-of-hooks
const i18n = use(initReactI18next).init({
  ...i18nDefaultConfig,
  ns: [
    "app",
    "@gx1/gx-npm-ui",
    "@gx1/gx-ui-common",
  ],
  resources: {
    en: {
      app: appTranslations,
      "@gx1/gx-npm-ui": gxNpmUiTranslations,
      "@gx1/gx-ui-common": gxUiCommonTranslations,
    },
  },
});

export default i18n;
